"use client";
import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { FaLink } from "react-icons/fa";
import { Logo } from '@/components/Logo';


export default function RegisterPage() {
    const [identifier, setIdentifier] = useState('');
    const [passkey, setPasskey] = useState('');
    const [avatarcolor, setAvatarcolor] = useState('#000000');
    const [password, setPassword] = useState("");
    const [popup, setPopup] = useState<{ show: boolean, message: string }>({ show: false, message: '' });

    const [stats, setStats] = useState<{ games: number; availableGames: number; players: number } | null>(null);
    []
    useEffect(() => {
        let socketRef = { current: undefined as import('socket.io-client').Socket | undefined };
        let intervalRef = { current: undefined as ReturnType<typeof setInterval> | undefined };
        import('socket.io-client').then(({ io }) => {
            socketRef.current = io({ path: '/api/socketio' });
            socketRef.current.on('stats', (data) => {
                setStats(data);
            });
            intervalRef.current = setInterval(() => {
                socketRef.current?.emit('get-stats');
            }, 5000);
            socketRef.current.emit('get-stats');
        });
        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
            if (socketRef.current) socketRef.current.disconnect();
        };
    }, []);

    // On mount, initialize from URL params if present
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const params = new URLSearchParams(window.location.search);
            const id = params.get('identifier');
            const pk = params.get('passkey');
            const pc = params.get('avatarcolor');
            //const pw = params.get('password');
            if (id) setIdentifier(id);
            if (pk) setPasskey(pk);
            if (pc) setAvatarcolor(pc);
            //if (pw) setPassword(pw);
        }
    }, []);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!identifier.trim() || !passkey.trim()) {
            alert('Identifier and Passkey are required.');
            return;
        }

        // Ensure a color is selected, default to black
        const color = avatarcolor && avatarcolor.trim() ? avatarcolor : '#000000';

        const params = new URLSearchParams({
            identifier,
            passkey,
            avatarcolor: color,
        }).toString();
        window.location.href = `/lobby?${params}`;
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
            <div className="bg-white p-8 rounded shadow-md w-full max-w-md mb-4">
                <h2 className="text-xl font-semibold mb-2 text-center">Usage Statistics</h2>
                {stats ? (
                    <div className="mb-4 text-center">
                        <div>Games: <span className="font-bold">{stats.games}</span></div>
                        <div>Waiting Games: <span className="font-bold">{stats.availableGames}</span></div>
                        <div>Players: <span className="font-bold">{stats.players}</span></div>
                    </div>
                ) : (
                    <div className="mb-4 text-center text-gray-500">Loading statistics...</div>
                )}
            </div>
            <form onSubmit={handleSubmit} className="bg-white p-8 rounded shadow-md w-full max-w-md">

                <h1 className="w-full text-2xl font-extrabold mb-4 flex items-center justify-center gap-3 text-blue-700 drop-shadow-sm text-center">
                    <Logo />
                    Gotcha! by NoRiddle
                </h1>
                <div className="mb-4">
                    <label className="block mb-2 font-medium" htmlFor="identifier">Identifier / Name</label>
                    <input
                        id="identifier"
                        type="text"
                        value={identifier}
                        onChange={e => setIdentifier(e.target.value)}
                        className="w-full px-3 py-2 border rounded"
                        required
                    />
                </div>
                <div className="mb-4">
                    <label className="block mb-2 font-medium" htmlFor="passkey">Pass Key (For arranged rooms)</label>
                    <div className="flex gap-2">
                        <input
                            id="passkey"
                            type="text"
                            value={passkey}
                            onChange={e => setPasskey(e.target.value)}
                            className="flex-1 px-3 py-2 border rounded"
                            required
                        />
                        <button
                            type="button"
                            onClick={() => setPasskey(uuidv4())}
                            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                        >
                            Create
                        </button>
                        <button
                            type="button"
                            className="px-2 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                            title="Copy share link"
                            onClick={() => {
                                const { origin } = window.location;
                                const url = `${origin}/lobby?passkey=${passkey}`;
                                navigator.clipboard.writeText(url);
                                setPopup({ show: true, message: 'Link copied to clipboard!' });
                            }}
                        >
                            <FaLink className="w-5 h-5 text-white" />
                        </button>
                    </div>
                </div>
                <div className="mb-6">
                    <label className="block mb-2 font-medium" htmlFor="avatarcolor">Avatar Color</label>
                    <input
                        id="avatarcolor"
                        type="color"
                        value={avatarcolor}
                        onChange={e => setAvatarcolor(e.target.value)}
                        className="w-full h-12 p-1 border rounded"
                        required
                    />
                </div>

                <button
                    type="submit"
                    className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
                >
                    Join Game
                </button>
                <button
                    type="button"
                    className="w-full mt-2 bg-yellow-600 text-white py-2 rounded hover:bg-yellow-700 transition"
                    onClick={() => window.location.href = '/'}
                >
                   Credits / How To Play
                </button>
            </form>
            {/* Custom Popup */}
            {popup.show && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center" style={{ zIndex: 9999 }}>
                    <div className="bg-white rounded-lg shadow-2xl p-6 max-w-md w-full mx-4">
                        <p className="text-lg text-gray-800 mb-4 text-center">{popup.message}</p>
                        <button
                            className="w-full px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                            onClick={() => setPopup({ show: false, message: '' })}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
